require('./accountDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ commons
const { formatText } = require('core/i18n').i18n;
// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { IbanModal } = require('components/ibanModal/ibanModal');
// @ actions
const accountsActions = require('actions/getAccounts');
// @ herlpers
import { formatInterest } from 'utilities/currencyHelper';
const { formatIbanString } = require('commonsUtilities/stringHelper');
const dateHelper = require('utilities/dateHelper');
//@ constants
const { DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR } = require('constants/index');
const { SAVINGS_ACCOUNT_TYPE} = require('constants/index');

class AccountDetails extends React.Component {
    constructor() {
        super();
        this.handleModalToggle = this.handleModalToggle.bind(this);
    }

    handleModalToggle() {
        const { toggleIbanModal } = this.props;
        toggleIbanModal();
    }

    render() {
        const { immAccount } = this.props;
        const iban = formatIbanString(immAccount.get('iban'));
        const product = immAccount.getIn(['catalogData','product']) || formatText('broker-searchResultsNotAvailableData');
        const accountType = immAccount.getIn(['catalogData', 'subtype']) || formatText('broker-searchResultsNotAvailableData');
        const headerTitle = formatText('accountDetails-dataSubtitle');
        const openingDate = immAccount.get('openingDate');
        const openingDateFormat = openingDate ? dateHelper.formatDate(openingDate, DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR) : '-';
        const isSavingAccount = immAccount.get('newProduct') === SAVINGS_ACCOUNT_TYPE;
        const renderOpeningDate = (!__CONTACT_CENTER__ && isSavingAccount) ||  __CONTACT_CENTER__;
        const formattedTin = immAccount.getIn(['rates', 'tin']) !== null ? formatInterest(immAccount.getIn(['rates', 'tin']), true, false) : null;
        const isHasToShowTin = isSavingAccount && formattedTin;
        const extraContent = (
            <div className="account-details__iban-content">
                {iban}
                <i className="icon-informacion account-details__iban-icon" onClick={this.handleModalToggle}></i>
            </div>
         );

        return (
            <article className="account-details">
                <IbanModal onRequestClose={this.handleModalToggle} />
                <section>
                    <header className="account-details__title">
                        <OKBoxTitle value={headerTitle} />
                    </header>
                    <OKInformativeList title="" columns={2}>
                        <OKInformativeListItem title="accountDetails-iban">
                            {extraContent}
                        </OKInformativeListItem>
                        <OKInformativeListItem title="accountDetails-product" bodyText={product} />
                        <OKInformativeListItem title="accountDetails-accountType" bodyText={accountType} />
                        <OKInformativeListItem title="accountDetails-swiftBic" bodyText="accountDetails-swiftBicText" />
                        {
                            isHasToShowTin &&
                                <OKInformativeListItem 
                                    title="contractsView-tin" 
                                    bodyText={formattedTin}
                                    icon
                                    tooltipType="explicative"
                                    tooltipPlacement="top"
                                    tooltipOffset={[0, -10]}
                                    information={formatText('accountDetails-tinExplanation')} 
                                />
                        }
                        {
                            renderOpeningDate &&
                                <OKInformativeListItem title="aggregatorLoanView-beginDate"  bodyText={openingDateFormat} />
                        }
                    </OKInformativeList>
                </section>
            </article>
        );
    }
}

AccountDetails.propTypes = {
    immAccount: PropTypes.object.isRequired,
    toggleIbanModal: PropTypes.func.isRequired
};

module.exports.AccountDetails = connect(null,{
        toggleIbanModal: accountsActions.toggleIbanModal
    })(AccountDetails);
